import { type FC } from 'react';
import { Button } from 'dibs-elements/exports/Button.tsx';
import { FormattedMessage } from 'dibs-react-intl';
import styles from './styles/ApplyNowButton.scss';

type Props = {
    onClick: () => void;
    className?: string;
    size?: 'small' | 'large' | 'medium';
};

const ApplyNowButton: FC<Props> = ({ onClick, className, size }) => {
    return (
        <div className={className || styles.wrapper}>
            <Button dataTn="apply-now" size={size} onClick={onClick}>
                <FormattedMessage id="ApplyNowButton.buttonText" defaultMessage="Apply Now" />
            </Button>
        </div>
    );
};

export default ApplyNowButton;
